export const actionTypes = {
  SELECT_STORE: 'SELECT_STORE',
  SET_SEARCH_ALL: 'SET_SEARCH_ALL',
  SET_USER: 'SET_USER',
  HYDRATE_LOCAL_STATE: 'HYDRATE_LOCAL_STATE',
  HANDLE_SEARCH: 'HANDLE_SEARCH',
  HANDLE_DRAWER: 'HANDLE_DRAWER',
  HANDLE_RENTAL: 'HANDLE_RENTAL',
  HANDLE_NOTIFICATION_OPEN: 'HANDLE_NOTIFICATION_OPEN',
  HANDLE_NOTIFICATION_DATA: 'HANDLE_NOTIFICATION_DATA'
}

export default {
  [actionTypes.HYDRATE_LOCAL_STATE]: (state, action) => {
    return  { ...state, ...action.payload }
  },
  [actionTypes.HANDLE_SEARCH]: (state, action) => {
    return  { ...state, search: { ...state.search, ...action.payload } }
  },
  [actionTypes.SELECT_STORE]: (state, action) => {
    return  { ...state, currentStore: action.payload }
  },
  [actionTypes.SET_SEARCH_ALL]: (state, action) => {
    return  { ...state, searchAll: action.payload }
  },
  [actionTypes.SET_USER]: (state, action) => {
    return  { ...state, user: action.payload }
  },
  [actionTypes.HANDLE_DRAWER]: (state, action) => {
    return  { ...state, drawer: action.payload }
  },
  [actionTypes.HANDLE_RENTAL]: (state, action) => {
    return  { ...state, rental: action.payload }
  },
  [actionTypes.HANDLE_NOTIFICATION_OPEN]: (state, action) => {
    return  { ...state, notification: { ...state.notification, open: action.payload } }
  },
  [actionTypes.HANDLE_NOTIFICATION_DATA]: (state, action) => {
    return  { ...state, notification: { ...state.notification, data: action.payload } }
  }
}